import MaterialSymbol from '../components/MaterialSymbol.vue';

export function registerMaterialSymbol(vueApp) {
    vueApp.component('MaterialSymbol', MaterialSymbol);
    vueApp.component('material-symbol', MaterialSymbol);
}
